import { apiIsomorphicFetchInvoice } from '#/api/invoice/apiFetchInvoice';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { viewInvoiceRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { ViewInvoicePageLoadable } from './ViewInvoicePageLoadable';

export async function loader({
  request,
  context,
  params: { invoiceId },
}: HorizonAppRouteLoaderArgs<typeof viewInvoiceRoute>) {
  const [data] = await Promise.all([
    apiIsomorphicFetchInvoice({ request, context })(invoiceId),
    ViewInvoicePageLoadable.load(),
  ]);

  return data;
}

export default function ViewInvoiceHorizonRoute({
  loaderData: { org, invoice },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: invoice page title, in org dashboard */
        i18n('%(invoiceType)s #%(invoiceNumber)s', {
          invoiceNumber: invoice.number,
          invoiceType: i18n('Invoice'),
        })
      }
    >
      <ViewInvoicePageLoadable org={org} invoice={invoice} />
    </RouteModule>
  );
}
